/* Packaging Wise — draft-theme mobile product hierarchy.
 * Mobile: ATC -> DPD -> Bundle -> assurance/specifications -> description.
 * Reuses the existing rendered nodes, restores them on desktop.
 */
(() => {
  'use strict';
  if (window.__PW_MOBILE_PRODUCT_FLOW__) return;
  window.__PW_MOBILE_PRODUCT_FLOW__ = true;
  const breakpoint = window.matchMedia('(max-width: 768px)');
  const moved = [];
  let container = null;
  let retry = 0;
  let retryTimer = 0;

  function restore() {
    for (const { element, marker } of moved) {
      if (marker.parentNode) marker.parentNode.insertBefore(element, marker);
      marker.remove();
    }
    moved.length = 0;
    container?.remove();
    container = null;
  }

  function move(element) {
    if (!element || moved.some(record => record.element === element)) return;
    const marker = document.createComment('PW mobile order restore');
    element.before(marker);
    moved.push({ element, marker });
    container.appendChild(element);
  }

  function apply() {
    window.clearTimeout(retryTimer);
    if (!breakpoint.matches) { restore(); return; }
    if (!document.body.classList.contains('template-product')) return;

    const product = document.querySelector('.page-content--product:not([data-modal="true"])');
    const meta = product?.querySelector('.product-single__meta');
    const bundle = document.querySelector('[data-pw-bundle-rules]');
    const bundleSection = bundle?.closest('.shopify-section, [id^="shopify-section-"]');
    // Only reorder products with a visible bundle. Never move quick-view content.
    if (!meta || !bundleSection || !bundleSection.parentNode) return;

    let assurance = moved.find(record => record.element.matches?.('[data-pw-product-assurance]'))?.element
      || meta.querySelector('[data-pw-product-assurance]');
    if (!assurance && retry++ < 8) {
      retryTimer = window.setTimeout(apply, 90);
      return;
    }
    if (!assurance) return;

    if (!container) {
      container = document.createElement('section');
      container.className = 'pw-mobile-after-bundle page-width';
      container.setAttribute('data-pw-mobile-after-bundle', '');
      bundleSection.insertAdjacentElement('afterend', container);
    }

    // Reuse the already initialized feature bullets/inventory and specs rather
    // than cloning elements or re-rendering Liquid and duplicating analytics.
    move(product.querySelector('[data-pw-left-details]'));
    move(assurance);
  }

  const schedule = () => {
    window.clearTimeout(retryTimer);
    retryTimer = window.setTimeout(apply, 0);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else schedule();

  if (breakpoint.addEventListener) breakpoint.addEventListener('change', apply);
  else breakpoint.addListener(apply);
  document.addEventListener('shopify:section:load', schedule);

  // The bundle app can render after DOMContentLoaded. Recheck only for a
  // short initial hydration window; avoid observing the entire DOM forever.
  if (breakpoint.matches) {
    const observer = new MutationObserver(() => {
      if (!container && document.querySelector('[data-pw-bundle-rules]')) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 12000);
  }
})();
